export default {"src":"/_next/static/media/beheerder.4ae1d51d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};